import { apiService } from '@paysense-india-services/payufin-jsutils'

import { ROUTES } from '@/constants/routes'

import { isAuthRoute } from '@/utils/authRoutes'
import { withProductParams } from '@/utils/queryParams'

import { getApiUrl } from '@/config/products'
import {
  clearAuthenticatedSession,
  clearAuthSession,
  getStoredReturnUrl,
  getStoredSource
} from '@/config/sourceStorage'

const BASE_PATH = import.meta.env.VITE_BASE_PATH.replace(/\/$/, '')

const getAppRelativePath = () => {
  if (typeof window === 'undefined') return '/'

  const currentPath = window.location.pathname.replace(/\/$/, '') || '/'

  if (currentPath === BASE_PATH || currentPath.startsWith(`${BASE_PATH}/`)) {
    return currentPath.slice(BASE_PATH.length) || '/'
  }

  return currentPath
}

const isOnAuthPage = () => isAuthRoute(getAppRelativePath())

export const buildLoginUrl = ({ source, returnUrl } = {}) => {
  const resolvedSource = source || getStoredSource()
  const resolvedReturnUrl = returnUrl ?? getStoredReturnUrl()
  const params = withProductParams({ source: resolvedSource, returnUrl: resolvedReturnUrl })
  return `${BASE_PATH}${ROUTES.LOGIN}?${params.toString()}`
}

export const performLogout = async (config = {}) => {
  const onAuthPage = isOnAuthPage()

  if (onAuthPage) {
    clearAuthenticatedSession()
  } else {
    clearAuthSession()
  }

  const logoutUrl = getApiUrl(config, 'logout')

  if (logoutUrl) {
    try {
      await apiService.post(logoutUrl, {
        credentials: 'include',
        headers: {
          ...(config.platformKey ? { 'X-PLATFORM-KEY': config.platformKey } : {}),
          accept: 'application/json',
          'Content-Type': 'application/json'
        },
        data: {}
      })
    } catch {
      // proceed to login even if logout API fails
    }
  }

  if (!onAuthPage) {
    window.location.replace(buildLoginUrl({ source: config.source }))
  }
}
